export function getImage(path: string) {
  // 移除开头的斜杠，因为路径拼接时会自动添加
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return new URL(`../assets/images/${cleanPath}`, import.meta.url).href;
}
